<div class="loader" *ngIf="isloader">
  <img src="assets/images/loader.gif" />
</div>
<div class="page_content_{{ bankName | lowercase }}">
  <div class="container">
    <div class="row" *ngIf="dataLen > 0">
      <div class="p-4">
        <h4 class="text-center">TERMS & CONDITIONS</h4>

        <div class="banner mt-5">
          <img
            src="{{
              result['bannerImagePath']
                ? result['bannerImagePath']
                : 'assets/images/banner.png'
            }}"
          />
          <p><b [innerHtml]="result['offerTitle'] | sanitizeHtml"></b></p>
        </div>
        <p class="mt-4"><b>Rewards Rates:</b></p>
        <div [innerHtml]="result['offerDescription'] | sanitizeHtml"></div>
        <hr />
        <p><b>Rewards Terms & Conditions:</b></p>
        <div [innerHtml]="result['termsAndConditions'] | sanitizeHtml"></div>
      </div>
    </div>
    <div class="row" *ngIf="dataLen == 0">
      <div class="no-record text-center mt-5">
        <h2>No Data Found</h2>
        <p>Sorry, no records were found.</p>
      </div>
    </div>
  </div>
</div>
